<template>
  <div>
    <div class="datatable_search">
      <div class="per_page_selector" v-if="perPageShowStatus">
        <div class="form-group">
          <select class="form_global" v-model="form.per_page" @change="queryEvent">
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="75">75</option>
            <option value="100">100</option>
          </select>
        </div>
      </div>
      <div class="form-group" v-if="searchShowStatus">
        <input type="text" class="form_global" placeholder="Search" v-model="form.search" @keyup.enter="queryEvent">
        <span v-if="form.search" class="cross_ic cursor_pointer" @click.prevent="clearSearch">
          <i class='bx bx-x'></i>
        </span>
      </div>
    </div>
    <table :class="['table', {'centralized':centralized}, {table_bordered:!noborder},classname]">
      <thead v-if="header">
      <tr>
        <th v-if="serialized" style="width: auto;text-align: center;">#</th>
        <th v-for="(col, index) in columns" :key="index" @click="sorting(col)" :style="{ width: col.width ? col.width : 'auto' }">
          <div v-if="col.headerSlot">
            <slot :name="col.headerSlotName"></slot>
          </div>
          <div v-else>
            {{ col.label }}
            <div class="data_table_arrow" :class="[{'arrow_down': col.sortable && sortColumn === col.field && sortOrder === 'asc'}, {'arrow_up': col.sortable && sortColumn === col.field && sortOrder === 'desc'}]" v-if="col.sortable"></div>
          </div>

        </th>
      </tr>
      </thead>
      <tbody>
      <template v-if="rows.length > 0">
        <tr v-for="(row, i) in rows" :key="i">
          <td v-if="serialized" style="width: auto;text-align: center;">{{ getSerical(i+1)}}</td>
          <td v-for="(col, j) in columns" :key="j" @click.prevent="col.click ? col.click(row) : false">
            <div v-if="col.display" v-html="col.display(row)"></div>
            <div v-else-if="col.slot">
              <slot :row="row" :index="i" :name="col.field"></slot>
            </div>
            <template v-else>
              <span>{{ col.field.split('.').length > 1 ? (row[col.field.split('.')[0]] !== null ? row[col.field.split('.')[0]][col.field.split('.')[1]] : '') : row[col.field] }}</span>
            </template>
          </td>
        </tr>
      </template>
      <template v-else>
        <tr>
          <td :colspan="columns.length" class="text_center">
            <span class="font_italic color_grey_type2">You currently have 0 items.</span>
          </td>
        </tr>
      </template>

      <slot :name="'footer'"></slot>
      </tbody>
    </table>

    <pagination-component v-if="pagination && pagination.links" :pagination="pagination" @changePage="changePage"></pagination-component>
  </div>
</template>

<script>
import PaginationComponent from "@/components/shared/PaginationComponent";

export default {
  name: "TableComponent",
  components: {
    PaginationComponent
  },
  emits: ['pageChanged', 'sorting'],
  props: {
    classname: String,
    isLoading: {
      type: Boolean,
      require: true,
    },
    serialized: {
      type: Boolean,
      default: true,
    },
    pagination: {
      type: Object,
      required: false,
    },
    columns: {
      type: Array,
      default: () => {
        return [];
      },
    },
    header: Boolean,
    perPageShowStatus: {
      type:Boolean,
      default: false
    },
    searchShowStatus: {
      type:Boolean,
      default: false
    },
    centralized: {
      type:Boolean,
      default: false
    },
    noborder: Boolean,
    footer: {
      type: Array,
      default: () => {
        return [];
      },
    },
    rows: {
      type: Array,
      default: () => {
        return [];
      },
    },
    sortable: {
      type: Object,
      default: () => {
        return {
          order: "id",
          sort: "asc",
        };
      },
    },

  },
  data() {
    return {
      sortColumn: this.sortable.order,
      sortOrder: this.sortable.sort,
      form:{
        search: '',
        per_page: 10
      }
    }
  },
  methods: {
    sorting(column) {
      if (column.sortable) {
        if (column.field === this.sortColumn)
          this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
        else {
          this.sortOrder = 'asc';
        }

        this.sortColumn = column.field;
        this.$emit('sorting', {
          column: this.sortColumn,
          order: this.sortOrder
        });
      }
    },
    changePage(page) {
      this.$emit('pageChanged', page);
    },
    queryEvent() {
      this.$emit('queryEvent', this.form);
    },
    clearSearch(){
      this.form.search = ''
      this.$emit('queryEvent', this.form);
    },
    getSerical(index){
      if(this.pagination) {
        if(this.pagination.current_page > 1){
          let curretnpage = this.pagination.current_page - 1
          return (curretnpage * this.pagination.per_page) + index;
        } else {
          return index;
        }
      } else {
        return index;
      }
    }
  }
}
</script>
<style scoped>
.cross_ic.cursor_pointer{
  position: absolute;
  line-height: 40px;
  width: 15px;
  background: #d3d0d0;
  color: #000;
  right: 17px;
  text-align: center;
  font-size: 16px;
}
</style>
